export const createSocialProfileUrlFromHandle = (
  handle: string,
  platform: string
): string => {
  switch (platform) {
    case 'facebook':
      return `https://www.facebook.com/${handle}`;
    case 'instagram':
      return `https://www.instagram.com/${handle}`;
    case 'linkedin':
      return `https://www.linkedin.com/in/${handle}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${handle}`;
    case 'twitch':
      return `https://www.twitch.tv/${handle}`;
    case 'x':
      return `https://x.com/${handle}`;
    case 'youtube':
      return `https://www.youtube.com/@${handle}`;
    default:
      return '';
  }
};
